/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const more = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M4.5 8A1.25 1.25 0 1 1 2 8a1.25 1.25 0 0 1 2.5 0ZM8 9.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4.75 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
    />
  </svg>
)
export default more
